import { Box } from './_shared/Box'

export function EstimatedEvents({ car }) {
  if (!car.nextInspectionDate) return null
  return (
    <Box title="Neste EU kontroll">
      <p>{car.nextInspectionDate}</p>
    </Box>
  )
}
